import React from "react";
import ReactSelect from "react-select";
import { type CommonReactSelectWrapperProps } from "../models";
import { useReactSelectDropdown } from "../hooks";

interface ReactMultiSelectWrapperProps<T> extends CommonReactSelectWrapperProps<T, true> {
  options: T[]
}

const BaseMultiSelectDropdown = <T extends unknown>(props: ReactMultiSelectWrapperProps<T>) => {
  const reactSelect = useReactSelectDropdown(props);

  return <ReactSelect
    {...reactSelect.reactSelectProps}
    key={props.dropdownKey}
    ref={reactSelect.ref}
    options={props.options}
    isMulti
  />;
};

export default BaseMultiSelectDropdown;